import { InjectionToken, NgModule } from '@angular/core';
import {
  CrmDependencies,
  CrmInjectionToken,
  CrmMultiLocationDependencies,
  CrmMultilocationInjectionToken,
} from './tokens-and-interfaces';
import { ActivityCustomizationService } from './shared-services';

@NgModule({
  imports: [],
})
export class CrmCoreModule {
  static forRoot(
    config: InjectionToken<CrmDependencies>,
    multilocationConfig?: InjectionToken<CrmMultiLocationDependencies>,
  ) {
    return {
      ngModule: CrmCoreModule,
      providers: [
        {
          provide: CrmInjectionToken,
          useExisting: config,
          deps: [],
        },
        {
          provide: CrmMultilocationInjectionToken,
          useExisting: multilocationConfig || config,
          deps: [],
        },
        ActivityCustomizationService,
      ],
    };
  }
}
